import { useEffect } from "react";
import { useLocation } from "react-router";
import { IntlProvider } from "react-intl";
import { useAppConfig } from "@ct-react/core";
import { defaultLocale, useLocaleContext } from "@ct-react/locale";
import LocaleRoutes from "./routes";
import { getIntlMessages } from "./i18n";
import { SearchProvider } from "./contexts/search";
import Header from "./components/layout/header";
import SearchBarIntoLayout from "./components/layout/search-bar-wrapper";
import Footer from "./components/layout/footer";
import "./scss/global.scss";
import { WishlistProvider } from "./contexts/wishlist";

const App = () => {

  const { id, env } = useAppConfig();
  const { locale } = useLocaleContext();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = locale.code;
  }, [ locale ]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [ location.pathname ]);

  return (
    <IntlProvider locale={locale.code}
                  defaultLocale={defaultLocale.code}
                  messages={getIntlMessages(locale)}
                  onError={error => env === "development" ? void 0 : error}>
      <SearchProvider>
        <WishlistProvider>
          <meta property="og:locale" content={locale.code} />
          <meta property="og:type" content="website" />
          <meta property="og_site_name" content={id} />
          <Header />
          <SearchBarIntoLayout />
          <div className="main-wrap">
              <LocaleRoutes />
          </div>
          <Footer />
        </WishlistProvider>
      </SearchProvider>
    </IntlProvider>);

}

export default App;
